import { Component } from '@angular/core';
import { SectionHeadingComponent } from '../../ui/section-heading/section-heading.component';

@Component({
  selector: 'app-trust',
  standalone: true,
  imports: [SectionHeadingComponent],
  templateUrl: './trust.component.html',
  styleUrl: './trust.component.scss',
})
export class TrustComponent {
  items = [
    { title: 'Zero instalacji', text: 'Goście grają w przeglądarce telefonu.' },
    { title: 'Wyłączenie nic nie psuje', text: 'Stan gry kazdego gracza przechowuje serwer.' },
    { title: 'Punkty liczy serwer', text: 'Nikt nie podkręci sobie wyniku z telefonu.' },
    { title: 'Dane zostają u Was', text: 'Pytania widzi tylko Wasza sala.' },
  ];
}
